import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { ReactNode } from "react";

interface UnlockButtonProps {
    loading: boolean;
    disabled?: boolean;
    onClick: () => void;
    label?: ReactNode
}

export const UnlockButton: React.FC<UnlockButtonProps> = ({ loading, disabled = false, onClick, label }) => {
    return (
        <LoadingButton
            loading={loading}
            disabled={disabled}
            size="small"
            color="success"
            variant="contained"
            startIcon={<LockOpenIcon />}
            onClick={onClick}
        >
            {label ? label : <Localized id="unlock">Odblokuj</Localized>}
        </LoadingButton>
    );
};
